"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderAdvanceMaterialForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _mdbreact = require("mdbreact");

var _f1FileUploadReact = _interopRequireDefault(require("f1-file-upload-react"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _f1WysiwygReact = _interopRequireDefault(require("f1-wysiwyg-react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField"));

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _pickers = require("@material-ui/pickers");

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _reactSwitch = _interopRequireDefault(require("react-switch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var hasRequiredValidation = function hasRequiredValidation(field) {
  if (!field.hasOwnProperty("validators")) {
    return false;
  }

  var required = false;

  var _iterator = _createForOfIteratorHelper(field.validators),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var validation = _step.value;

      if (validation.name === "required" && validation.value == true) {
        required = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return required;
};

var renderFields = function renderFields(props, state, _onChange, t, row, handleAutocompleteSelect, _onEditorStateChange, onFileRef, onFileRemove, _renderUploadedFilesItem) {
  var model = props.model;
  var defaultValues = props.defaultValues;
  var outline = props.materialOutline;
  var autoCompleteItems = props.autoCompleteItems;
  var buttonNormalClick = props.buttonNormalClick;
  var showAstersikOnRequiredFields = props.showAstersikOnRequiredFields;
  var formUI = row.map(function (m, index) {
    var key = m.key;
    var label = m.label;
    var type = m.type || "text";
    var props = m.props || {};
    var name = m.key;
    var value = m.value;
    var pattern = m.pattern;
    var placeholder = m.placeholder;
    var required = m.required; //const { t } = props;

    var target = key;
    value = state[target] || "";
    var requiredFieldClass = hasRequiredValidation(m) && showAstersikOnRequiredFields ? " requiredField" : "";
    var className = state.errors[m.key] ? "form-control is-invalid" : "form-control";
    var classNameCheckbox = state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
    var classNameRadio = state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
    var errors = state.errors;
    var validationMessage = errors[m.key] ? state.errors[m.key] : "";
    var input = (m.hide ? false : true) ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, _extends({}, props, {
      className: className,
      icon: m.hasOwnProperty("icon") && m.icon ? m.icon : "",
      label: t(m.label),
      type: type,
      key: key,
      name: name,
      maxlength: m.maxlength,
      value: state[key],
      onChange: function onChange(e) {
        _onChange(e, target, "single", m);
      },
      outline: outline,
      id: m.id,
      disabled: m.disabled
    })) : "";

    if (type == "radio" && (m.hide ? false : true)) {
      input = m.options.map(function (o) {
        var _extends2;

        var checked = o.value === state[key];
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: "fr" + o.key
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "custom-control custom-radio"
        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, (_extends2 = {
          className: classNameRadio,
          type: type,
          key: o.key,
          id: o.key,
          name: o.name,
          checked: checked,
          value: o.value,
          autoComplete: m.autoComplete,
          onChange: function onChange(e) {
            _onChange(e, o.name, "single", m);
          }
        }, _defineProperty(_extends2, "id", o.id), _defineProperty(_extends2, "disabled", o.disabled), _extends2))), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: o.key,
          className: "grey-text custom-control-label",
          key: "ll" + o.key
        }, t(o.label))));
      });
      input = /*#__PURE__*/_react.default.createElement("div", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "grey-text",
        htmlFor: key
      }, t(label)), input);
    }

    if (type == "select" && (m.hide ? false : true)) {
      input = m.options.map(function (o) {
        var checked = o.value === state[key];
        return /*#__PURE__*/_react.default.createElement("option", _extends({}, props, o, {
          className: className,
          key: o.key,
          value: o.value
        }), t(o.label));
      });
      input = /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "grey-text",
        htmlFor: key
      }, t(label)), /*#__PURE__*/_react.default.createElement("select", {
        id: m.id,
        disabled: m.disabled,
        className: className,
        value: state[key],
        onChange: function onChange(e) {
          _onChange(e, m.key, "single", m);
        }
      }, input));
    }

    if (type == "tel" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
        className: className,
        type: "tel",
        key: key,
        name: name,
        value: state[key],
        placeholder: placeholder,
        label: label,
        pattern: pattern,
        required: required,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        outline: outline,
        id: m.id,
        disabled: m.disabled
      });
    }

    if (type == "range" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
        className: className,
        type: "range",
        key: key,
        name: name,
        value: state[key],
        placeholder: placeholder,
        label: label,
        pattern: pattern,
        required: required,
        min: m.min,
        max: m.max,
        step: m.step,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        outline: outline,
        id: m.id,
        disabled: m.disabled
      });
    }

    if (type === "CustomSwitch" && (m.hide ? !m.hide : true)) {
      input = /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
        onChange: function onChange(e) {
          _onChange(e, target, "switch", m);
        },
        checked: state[key],
        value: state[key],
        handleDiameter: m.handleDiameter,
        offColor: m.offColor,
        onColor: m.onColor,
        offHandleColor: m.offHandleColor,
        onHandleColor: m.onHandleColor,
        height: m.height,
        width: m.width,
        borderRadius: m.borderRadius,
        activeBoxShadow: m.activeBoxShadow,
        uncheckedHandleIcon: m.uncheckedHandleIcon,
        uncheckedIcon: m.uncheckedIcon,
        boxShadow: m.boxShadow,
        id: m.id,
        className: m.className,
        disabled: m.disabled,
        checkedIcon: m.checkedIcon
      });
    }

    if (type === "materialSwitch" && (m.hide ? !m.hide : true)) {
      input = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Switch.default //  checked={ state[key] }
      , {
        value: state[key] // size={m.size}
        // disabled={m.disabled}
        // classes={m.classes}
        ,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        name: m.name,
        color: m.color,
        inputProps: {
          "aria-label": "Switch A"
        } //checkedIcon={m.checkedIcon}
        //disableRipple={m.disableRipple}
        //edge={m.edge}
        // icon={m.icon}
        // id={m.id}
        // inputProps={m.inputProps}
        // inputRef={m.inputRef}
        // required={m.required}

      }));
    }

    if (type === "materialDate" && (m.hide ? !m.hide : true)) {
      input = /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default
      }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, _extends({}, props, {
        readOnly: m.readOnly,
        inputVariant: m.inputVariant,
        minDate: m.minDate,
        maxDate: m.maxDate,
        label: m.fieldLabel,
        autoOk: m.autoOk,
        minDateMessage: m.minDateMessage,
        maxDateMessage: m.maxDateMessage,
        okLabel: m.okLabel,
        disableToolbar: m.disableToolbar,
        variant: m.variant,
        format: m.format,
        margin: m.margin,
        key: key,
        name: name,
        id: m.id,
        disabled: m.disabled,
        placeholder: m.placeholder,
        value: state[key] ? state[key] : null,
        className: className,
        allowKeyboardControl: m.allowKeyboardControl,
        onChange: function onChange(e) {
          //  console.log(e);
          _onChange(e, target, "advanceControl", m);
        },
        KeyboardButtonProps: {
          "aria-label": "change date"
        },
        showTodayButton: m.showTodayButton,
        clearable: m.clearable
      })));
    }

    if (type === "CustomSwitch" && (m.hide ? !m.hide : true)) {
      var _React$createElement;

      input = /*#__PURE__*/_react.default.createElement(_reactSwitch.default, (_React$createElement = {
        onChange: function onChange(e) {
          _onChange(e, target, "switch", m);
        },
        checked: state[key],
        value: state[key],
        handleDiameter: m.handleDiameter,
        offColor: m.offColor,
        onColor: m.onColor,
        offHandleColor: m.offHandleColor,
        onHandleColor: m.onHandleColor,
        height: m.height,
        width: m.width,
        borderRadius: m.borderRadius,
        activeBoxShadow: m.activeBoxShadow,
        uncheckedHandleIcon: m.uncheckedHandleIcon,
        uncheckedIcon: m.uncheckedIcon,
        boxShadow: m.boxShadow,
        id: m.id,
        className: m.className,
        disabled: m.disabled
      }, _defineProperty(_React$createElement, "uncheckedHandleIcon", m.uncheckedHandleIcon), _defineProperty(_React$createElement, "uncheckedIcon", m.uncheckedIcon), _defineProperty(_React$createElement, "boxShadow", m.boxShadow), _defineProperty(_React$createElement, "id", m.id), _defineProperty(_React$createElement, "className", m.className), _defineProperty(_React$createElement, "disabled", m.disabled), _defineProperty(_React$createElement, "checkedIcon", m.checkedIcon), _React$createElement));
    }

    if (type === "materialSwitch" && (m.hide ? !m.hide : true)) {
      var _React$createElement2;

      input = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Switch.default //  checked={ state[key] }
      , (_React$createElement2 = {
        value: state[key],
        size: m.size,
        disabled: m.disabled,
        classes: m.classes,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        name: m.name,
        color: m.color,
        inputProps: {
          "aria-label": "Switch A"
        } //checkedIcon={m.checkedIcon}
        //disableRipple={m.disableRipple}
        //edge={m.edge}
        //icon={m.icon}
        ,
        id: m.id
      }, _defineProperty(_React$createElement2, "inputProps", m.inputProps), _defineProperty(_React$createElement2, "inputRef", m.inputRef), _defineProperty(_React$createElement2, "required", m.required), _React$createElement2)));
    }

    if (type == "date" && (m.hide ? false : true)) {
      var d = new Date();
      var month = d.getMonth() <= 8 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() <= 9 ? "0" + d.getDate() : d.getDate();
      var time = d.getFullYear() + "-" + month + "-" + day;
      input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
        className: className,
        type: "date",
        key: key,
        name: name,
        label: label,
        value: state[key] ? state[key] : m.noDate === null ? null : time,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        outline: outline,
        id: m.id,
        disabled: m.disabled,
        min: m.min,
        max: m.max,
        placeholder: m.placeholder,
        format: m.format
      });
    }

    if (type == "datetime-local" && (m.hide ? false : true)) {
      var _d = new Date();

      var _month = _d.getMonth() <= 8 ? "0" + (_d.getMonth() + 1) : _d.getMonth() + 1;

      var _day = _d.getDate() <= 9 ? "0" + _d.getDate() : _d.getDate();

      var _time = _d.getFullYear() + "-" + _month + "-" + _day + "T" + _d.getHours() + ":" + _d.getMinutes();

      input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
        className: className,
        type: "datetime-local",
        key: key,
        name: name,
        label: label,
        value: state[key] ? state[key] : _time,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        outline: outline,
        id: m.id,
        disabled: m.disabled,
        min: m.min,
        max: m.max,
        placeholder: m.placeholder,
        format: m.format
      });
    }

    if (type == "link" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement("a", {
        href: m.href,
        key: key,
        id: m.id
      }, m.value);
    }

    if (type == "button" && (m.hide ? false : true)) {
      input = m.customButton ? /*#__PURE__*/_react.default.createElement("span", {
        key: key,
        id: m.id
      }, m.customButton) : /*#__PURE__*/_react.default.createElement("button", _extends({
        type: m.type,
        className: m.className,
        key: key,
        id: m.id
      }, m, {
        onClick: function onClick() {
          return buttonNormalClick(m.id, m.key, state);
        }
      }), m.value);
    }

    if (type === "label" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement("label", {
        className: m.key + " " + m.className
      }, t(m.value));
    }

    if (type === "autocomplete" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement(_reactAutocomplete.default, {
        items: autoCompleteItems[key],
        shouldItemRender: function shouldItemRender(item, value) {
          return item.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
        },
        getItemValue: function getItemValue(item) {
          return item.label;
        },
        renderItem: function renderItem(item, highlighted) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "items-wrapper",
            key: item.id,
            style: {
              backgroundColor: highlighted ? "#eee" : "transparent",
              position: "relative"
            }
          }, item.label);
        },
        renderMenu: function renderMenu(items, value, style) {
          if (items.length > 0) {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "autocomple-menu-wrapper",
              style: _objectSpread(_objectSpread({}, style), props.menuStyle),
              children: items
            });
          } else {
            return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
          }
        },
        value: state[key + "label"],
        name: key + "label",
        wrapperStyle: {},
        wrapperProps: {
          className: "md-form md-outline autocomplete-wrapper"
        },
        inputProps: {
          className: "form-control form-control",
          type: "text",
          label: m.label,
          placeholder: m.placeholder,
          disabled: m.disabled
        },
        onChange: function onChange(e) {
          _onChange(e, key + "label", "single", m);

          _onChange(e, key, "single", m);
        },
        onSelect: function onSelect(value, item) {
          handleAutocompleteSelect(value, item, key);
          var event = new Event('autocompleteEvent'); //console.log(item)

          Object.defineProperty(event, 'target', {
            writable: false,
            value: {
              'value': item.id
            }
          });

          _onChange(event, key, "single", m);
        }
      });
    }

    if (type === "autocompleteMultiselect" && (m.hide ? !m.hide : true)) {
      input = /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
        multiple: true,
        options: m.options,
        getOptionLabel: function getOptionLabel(option) {
          return option.key;
        } // defaultValue={[{ title: 'The Shawshank Redemption', year: 1994 }]}
        ,
        className: className,
        value: state[key],
        onChange: function onChange(e, newValue) {
          _onChange(e, m.key, "autocompleteMultiselect", m, newValue);
        },
        id: m.id,
        disabled: m.disabled,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
            placeholder: m.placeholder
          }));
        }
      });
    }

    if (type === "textarea" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, _extends({}, props, {
        className: className,
        icon: m.hasOwnProperty("icon") && m.icon ? m.icon : "",
        label: t(m.label),
        type: "textarea",
        rows: m.rows,
        key: key,
        name: name,
        value: state[key],
        placeholder: m.placeholder,
        onChange: function onChange(e) {
          _onChange(e, target, "single", m);
        },
        outline: outline,
        disabled: m.disabled,
        id: m.id
      }));
    }

    if (type === "file" && (m.hide ? false : true)) {
      var str = new String(m.regex);
      var str1 = eval(str.toString());
      input = /*#__PURE__*/_react.default.createElement(_f1FileUploadReact.default, _extends({
        onDropHandler: function onDropHandler(files, event) {
          _onChange(files, target, "file", m);
        },
        componentType: m.componentType,
        acceptFileTypes: m.acceptFileTypes,
        dropTitle: m.dropTitle,
        maxFileSize: m.maxFileSize,
        onFileRemove: onFileRemove,
        renderUploadedFilesItem: function renderUploadedFilesItem(file, index) {
          return _renderUploadedFilesItem(file, index, m.key);
        },
        onRef: function onRef(ref) {
          return onFileRef(ref, m.key);
        },
        defaultUploadedFiles: state[key]
      }, m, {
        regex: str1
      }));
    }

    if (type === "texteditor" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement("div", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: m.key,
        className: ""
      }, t(m.label)), /*#__PURE__*/_react.default.createElement(_f1WysiwygReact.default, _extends({
        editorState: state["editorState" + m.key]
      }, m, {
        onEditorStateChange: function onEditorStateChange(editorState) {
          return _onEditorStateChange(editorState, m);
        },
        defaultContent: state[key]
      })));
    }

    if (type == "checkbox" && (m.hide ? false : true)) {
      input = m.options.map(function (o) {
        //let checked = o.value == value;
        var checked = false;

        if (value && value.length > 0) {
          checked = value.indexOf(o.value) > -1 ? true : false;
        }

        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: "cfr" + o.key
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "custom-control custom-checkbox"
        }, o.tooltipTitle ? /*#__PURE__*/_react.default.createElement("i", {
          className: "fa fa-info-circle field-child-tooltip",
          title: o.tooltipTitle
        }) : "", /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
          className: classNameCheckbox,
          type: type,
          key: o.key,
          id: o.key,
          name: o.name,
          checked: checked,
          value: o.value,
          onChange: function onChange(e) {
            _onChange(e, m.key, "multiple", m);
          },
          disabled: o.disabled
        })), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: o.key,
          className: "custom-control-label grey-text",
          key: "ll" + o.key
        }, t(o.label))));
      });
      input = /*#__PURE__*/_react.default.createElement("div", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "grey-text",
        htmlFor: key
      }, t(label)), input);
    }

    if (type == "icon" && (m.hide ? false : true)) {
      input = /*#__PURE__*/_react.default.createElement("span", {
        key: key,
        id: m.key
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: m.path,
        name: m.name,
        className: "imgIcon"
      }));
    }

    return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
      md: m.colmd,
      lg: m.collg,
      sm: m.colsm,
      xs: m.colxs,
      key: "g" + key
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group control-" + m.key + requiredFieldClass,
      id: "field" + m.key + index
    }, input, (m.hide ? false : true) ? validationMessage ? /*#__PURE__*/_react.default.createElement("span", {
      className: "text-danger"
    }, " ", t(validationMessage)) : "" : ""));
  });
  return formUI;
};

var renderFieldSetRows = function renderFieldSetRows(props, state, onChange, t, columnsRows, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem) {
  var rows = columnsRows.map(function (row, index) {
    return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, {
      key: index
    }, renderFields(props, state, onChange, t, row, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem));
  });
  return rows;
};

var renderChildFieldset = function renderChildFieldset(props, state, onChange, t, fieldsets, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel) {
  var childFieldsets = fieldsets.map(function (fieldset, index) {
    return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, {
      className: fieldset.fieldSetClassName,
      key: "child_fieldset" + index
    }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
      md: "12",
      xs: "12"
    }, fieldset.fieldSetLabelType === "component" ? /*#__PURE__*/_react.default.createElement(fieldset.fieldSetLabel, null) : fieldset.fieldSetLabelType === "accordian" ? renderFieldsetAccordianLabel ? renderFieldsetAccordianLabel(fieldset.fielsetId) : /*#__PURE__*/_react.default.createElement("p", {
      onClick: function onClick() {
        return toggleCollapse(fieldset.fielsetId);
      }
    }, t(fieldset.fieldSetLabel)) : /*#__PURE__*/_react.default.createElement("label", null, t(fieldset.fieldSetLabel)), fieldset.fieldSetLabelType === "accordian" ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCollapse, {
      id: fieldset.fielsetId,
      isOpen: state.collapseStates && state.collapseStates.hasOwnProperty(fieldset.fielsetId) && state.collapseStates[fieldset.fielsetId]
    }, renderFieldSetRows(props, state, onChange, t, fieldset.rows, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem)) : renderFieldSetRows(props, state, onChange, t, fieldset.rows, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem)));
  });
  return childFieldsets;
};

var renderColumns = function renderColumns(props, state, onChange, t, fieldset, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel) {
  var columns = fieldset && fieldset.columns.map(function (column, index) {
    return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
      md: column.colmd,
      lg: column.collg,
      sm: column.colsm,
      xs: column.colxs,
      key: index
    }, column.hasOwnProperty("childType") && column.childType === "fieldset" ? renderChildFieldset(props, state, onChange, t, column.fieldsets, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel) : renderFieldSetRows(props, state, onChange, t, column.rows, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem));
  });
  return columns;
};

var renderAdvanceMaterialForm = function renderAdvanceMaterialForm(props, state, onChange, t, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel) {
  var fieldsets = props.model.map(function (fieldset, index) {
    return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, {
      className: fieldset.fieldSetClassName,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
      md: "12",
      xs: "12"
    }, fieldset.fieldSetLabelType === "component" ? /*#__PURE__*/_react.default.createElement(fieldset.fieldSetLabel, null) : fieldset.fieldSetLabelType === "accordian" ? renderFieldsetAccordianLabel ? renderFieldsetAccordianLabel(fieldset.fielsetId) : /*#__PURE__*/_react.default.createElement("p", {
      onClick: function onClick() {
        return toggleCollapse(fieldset.fielsetId);
      }
    }, t(fieldset.fieldSetLabel)) : /*#__PURE__*/_react.default.createElement("label", null, t(fieldset.fieldSetLabel)), fieldset.fieldSetLabelType === "accordian" ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCollapse, {
      id: fieldset.fielsetId,
      isOpen: state.collapseStates && state.collapseStates.hasOwnProperty(fieldset.fielsetId) && state.collapseStates[fieldset.fielsetId]
    }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, renderColumns(props, state, onChange, t, fieldset, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel))) : /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, renderColumns(props, state, onChange, t, fieldset, handleAutocompleteSelect, onEditorStateChange, onFileRef, onFileRemove, renderUploadedFilesItem, toggleCollapse, renderFieldsetAccordianLabel))));
  });
  return fieldsets;
};

exports.renderAdvanceMaterialForm = renderAdvanceMaterialForm;